import Swal from "sweetalert2";
import categoryService from "../services/category";
import i18n from "../i18n/i18n";

const t = (key, opts) => i18n.t(key, opts);

// Map the English entity word passed by the Manage pages to a translated label
// so dynamic titles like "Update category" render in the active language.
const entityLabel = (word) => {
	const map = {
		category: "category",
		condition: "col_condition",
		type: "col_type",
		city: "col_city",
		"sub category": "sub_category"
	};
	return map[word] ? t(map[word]) : word;
};

export const swalDeleteForm = callback => {
	Swal.fire({
		title: t("swal_are_you_sure"),
		text: t("swal_revert_warning"),
		icon: "warning",
		showCancelButton: true,
		confirmButtonColor: "#d33",
		cancelButtonColor: "#3085d6",
		confirmButtonText: t("btn_delete")
	}).then(result => {
		if (result.value) {
			callback();
		}
	});
};

export const swalDelete = callback => {
	Swal.fire({
		title: t("swal_are_you_sure"),
		text: t("swal_revert_warning"),
		icon: "warning",
		showCancelButton: true,
		confirmButtonColor: "#d33",
		cancelButtonColor: "#3085d6",
		confirmButtonText: t("btn_delete")
	}).then(result => {
		if (result.value) {
			callback();
		}
	});
};

export const swalConfirm = ({ title, callback }) => {
	Swal.fire({
		title: title || t("swal_are_you_sure"),
		icon: "warning",
		showCancelButton: true,
		confirmButtonColor: "#3085d6",
		cancelButtonColor: "#d33",
		confirmButtonText: t("swal_yes_do_it")
	}).then(result => {
		if (result.value) {
			callback();
		}
	});
};

export const swalError = message => {
	Swal.fire({
		position: "top-end",
		icon: "error",
		title: message,
		showConfirmButton: true
	});
};

export const swalSuccess = message => {
	Swal.fire({
		position: "top-end",
		icon: "success",
		title: message,
		showConfirmButton: false,
		timer: 800
	});
};

export const swalInfo = message => {
	Swal.fire({
		position: "top-end",
		icon: "info",
		title: message,
		showConfirmButton: true
	});
};

export const swalName = (name, callback) => {
	Swal.fire({
		title: t("swal_update_name_title"),
		html: `<input id="txt-name" type="text" class="swal2-input" value="${name}" placeholder="${t("full_name")}" />`,
		showConfirmButton: true,
		confirmButtonText: t("swal_update"),
		showCancelButton: true,
		cancelButtonText: t("swal_close"),
		preConfirm: () => {
			const name = document.getElementById("txt-name").value;
			if (!name || name.length === 0)
				return Swal.showValidationMessage(t("swal_provide_name"));
		}
	}).then(result => {
		if (result.value) {
			const name = document.getElementById("txt-name").value;
			callback(name);
		}
	});
};

export const swalPassword = callback => {
	Swal.fire({
		title: t("swal_update_password_title"),
		html: `
                <input id="txt-current-pass" type="password" class="swal2-input" placeholder="${t("swal_current_password")}" />
                <input id="txt-pass1" type="password" class="swal2-input" placeholder="${t("password_label")}" />
                <input id="txt-pass2" type="password" class="swal2-input" placeholder="${t("swal_repeat_password")}" />`,
		showConfirmButton: true,
		confirmButtonText: t("swal_update"),
		showCancelButton: true,
		cancelButtonText: t("swal_close"),
		preConfirm: () => {
			const currentPass =
				document.getElementById("txt-current-pass").value;
			if (!currentPass || currentPass.length === 0)
				return Swal.showValidationMessage(t("swal_provide_current_password"));

			const pass1 = document.getElementById("txt-pass1").value;
			if (!pass1 || pass1.length === 0)
				return Swal.showValidationMessage(t("swal_provide_password"));

			const pass2 = document.getElementById("txt-pass2").value;
			if (pass1 !== pass2)
				return Swal.showValidationMessage(t("swal_password_mismatch"));
		}
	}).then(result => {
		if (result.value) {
			const currentPass =
				document.getElementById("txt-current-pass").value;
			const password = document.getElementById("txt-pass1").value;
			callback(currentPass, password);
		}
	});
};

export const swalChangePassword = callback => {
	Swal.fire({
		title: t("change_password"),
		html: `<input id="txt-pass1" type="password" class="swal2-input" placeholder="${t("password_label")}" />
                <input id="txt-pass2" type="password" class="swal2-input" placeholder="${t("swal_repeat_password")}" />`,
		showConfirmButton: true,
		confirmButtonText: t("swal_update"),
		showCancelButton: true,
		cancelButtonText: t("swal_close"),
		preConfirm: () => {
			const pass1 = document.getElementById("txt-pass1").value;
			if (!pass1 || pass1.length === 0)
				return Swal.showValidationMessage(t("swal_provide_password"));

			const pass2 = document.getElementById("txt-pass2").value;
			if (pass1 !== pass2)
				return Swal.showValidationMessage(t("swal_password_mismatch"));
		}
	}).then(result => {
		if (result.value) {
			const password = document.getElementById("txt-pass1").value;
			callback(password);
		}
	});
};

export const swalShare = url => {
	Swal.fire({
		title: t("swal_copy_url_title"),
		html: `<input id="txt-share-url" type="text" class="swal2-input" readonly value="${url}" />`,
		position: "top-end",
		showConfirmButton: true,
		confirmButtonText: t("swal_copy_url_btn"),
		showCancelButton: true,
		cancelButtonText: t("swal_close")
	}).then(result => {
		if (result.value) {
			document.getElementById("txt-share-url").select();
			document.execCommand("copy");
			Swal.fire({
				position: "top-end",
				icon: "success",
				title: t("swal_copied"),
				showConfirmButton: false,
				timer: 800
			});
		}
	});
};

export const swalSmallForm = (obj, title, callback) => {
	let btnText = obj ? t("swal_update") : t("btn_create");
	const label = entityLabel(title);
	title = obj ? t("swal_update_title", { name: label }) : t("swal_create_title", { name: label });
	Swal.fire({
		title: title,
		html: `
                <input id="txt-title" type="text" class="swal2-input" placeholder="${t("col_title")}" />
                <select id="txt-active" class="swal2-input">
                    <option value="">${t("swal_select_status")}</option>
                    <option value="true">${t("col_active")}</option>
                    <option value="false">${t("col_inactive")}</option>
                </select>`,
		showConfirmButton: true,
		confirmButtonText: btnText,
		showCancelButton: true,
		cancelButtonText: t("swal_close"),
		didOpen: () => {
			document.getElementById("txt-title").focus();
			document.getElementById("txt-title").value =
				(obj && obj.title) || ``;
			document.getElementById("txt-active").value =
				(obj && `${obj.active}`) || ``;
		},
		preConfirm: () => {
			const title = document.getElementById("txt-title").value;
			if (!title || title.length === 0)
				return Swal.showValidationMessage(t("swal_provide_title"));

			const active = document.getElementById("txt-active").value;
			if (!active || active.length === 0)
				return Swal.showValidationMessage(t("swal_provide_status"));
		}
	}).then(result => {
		if (result.value) {
			const title = document.getElementById("txt-title").value;
			const active = document.getElementById("txt-active").value;
			callback(title, active);
		}
	});
};

export const swalCity = (obj, title, callback) => {
	let btnText = obj ? t("swal_update") : t("btn_create");
	const label = entityLabel(title);
	title = obj ? t("swal_update_title", { name: label }) : t("swal_create_title", { name: label });
	Swal.fire({
		title: title,
		html: `
                <input id="txt-title" type="text" class="swal2-input" placeholder="${t("col_title")}" />
                <select id="txt-active" class="swal2-input">
                    <option value="">${t("swal_select_status")}</option>
                    <option value="true">${t("col_active")}</option>
                    <option value="false">${t("col_inactive")}</option>
                </select>
                <input id="txt-lat" type="number" class="swal2-input" placeholder="${t("col_latitude")}" />
                <input id="txt-lng" type="number" class="swal2-input" placeholder="${t("col_longitude")}" />`,
		showConfirmButton: true,
		confirmButtonText: btnText,
		showCancelButton: true,
		cancelButtonText: t("swal_close"),
		didOpen: () => {
			document.getElementById("txt-title").focus();
			document.getElementById("txt-title").value =
				(obj && obj.title) || ``;
			document.getElementById("txt-active").value =
				(obj && `${obj.active}`) || ``;
			document.getElementById("txt-lat").value = (obj && obj.lat) || ``;
			document.getElementById("txt-lng").value = (obj && obj.lng) || ``;
		},
		preConfirm: () => {
			const title = document.getElementById("txt-title").value;
			if (!title || title.length === 0)
				return Swal.showValidationMessage(t("swal_provide_title"));

			const active = document.getElementById("txt-active").value;
			if (!active || active.length === 0)
				return Swal.showValidationMessage(t("swal_provide_status"));

			const lat = document.getElementById("txt-lat").value;
			if (!lat || lat.length === 0)
				return Swal.showValidationMessage(t("swal_provide_latitude"));

			const lng = document.getElementById("txt-lng").value;
			if (!lng || lng.length === 0)
				return Swal.showValidationMessage(t("swal_provide_longitude"));
		}
	}).then(result => {
		if (result.value) {
			const title = document.getElementById("txt-title").value;
			const active = document.getElementById("txt-active").value;
			const lat = document.getElementById("txt-lat").value;
			const lng = document.getElementById("txt-lng").value;
			callback(title, active, lat, lng);
		}
	});
};

export const swalSubCategoryForm = (obj, categories, callback) => {
	let btnText = obj ? t("swal_update") : t("btn_create");
	const label = t("sub_category");
	let title = obj ? t("swal_update_title", { name: label }) : t("swal_create_title", { name: label });
	Swal.fire({
		title: title,
		html: `
                <input id="txt-title" type="text" class="swal2-input" placeholder="${t("col_title")}" />
                <select id="txt-category" class="swal2-input"></select>
                <select id="txt-active" class="swal2-input">
                    <option value="">${t("swal_select_status")}</option>
                    <option value="true">${t("col_active")}</option>
                    <option value="false">${t("col_inactive")}</option>
                </select>`,
		showConfirmButton: true,
		confirmButtonText: btnText,
		showCancelButton: true,
		cancelButtonText: t("swal_close"),
		didOpen: async () => {
			document.getElementById("txt-title").focus();
			let html = `<option value="">${t("select_category")}</option>`;
			categories.forEach(
				category =>
					(html += `<option value="${category._id}">${category.title}</option>`)
			);
			document.getElementById("txt-category").innerHTML = html;
			document.getElementById("txt-title").value =
				(obj && obj.title) || ``;
			document.getElementById("txt-active").value =
				(obj && `${obj.active}`) || ``;
			document.getElementById("txt-category").value =
				(obj && obj.categoryId._id) || ``;
		},
		preConfirm: () => {
			const title = document.getElementById("txt-title").value;
			if (!title || title.length === 0)
				return Swal.showValidationMessage(t("swal_provide_title"));

			const category = document.getElementById("txt-category").value;
			if (!category || category.length === 0)
				return Swal.showValidationMessage(t("swal_provide_category"));

			const active = document.getElementById("txt-active").value;
			if (!active || active.length === 0)
				return Swal.showValidationMessage(t("swal_provide_status"));
		}
	}).then(result => {
		if (result.value) {
			const title = document.getElementById("txt-title").value;
			const categoryId = document.getElementById("txt-category").value;
			const active = document.getElementById("txt-active").value;
			callback(title, categoryId, active);
		}
	});
};
